import { render, staticRenderFns } from "./VideoOption.vue?vue&type=template&id=180843ef&scoped=true"
import script from "./VideoOption.vue?vue&type=script&lang=js"
export * from "./VideoOption.vue?vue&type=script&lang=js"
import style0 from "./VideoOption.vue?vue&type=style&index=0&id=180843ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180843ef",
  null
  
)

export default component.exports